import { IMetaResponse } from '../../../../shared/models/master.models';

export interface IDesignListResponse {
	data: IDesignListBody[];
	meta: IMetaResponse;
}

export interface IDesignListBody {
	uuid: string;
	name?: string;
	title: string;
	skin: string;
	theme_color: string;
	watermark: boolean;
	active: boolean;
	company_uuid?: string;
	created_at?: string;
	updated_at?: string;
}

export interface IDesignDetailResponse {
	data: IDesignDetailBody;
}

export interface IDesignDetailBody {
	uuid: string;
	name?: string;
	title: string;
	skin: string;
	theme_color: string;
	watermark: boolean;
	show_product_name?: boolean;
	custom_spinner?: string | null;
	favicon?: string | null;
	active: boolean;
	profiles: string[];
	css_configs: IDesignCSSConfig[];
	updated_at?: string;
	company_uuid?: string;
	logo?: string | null;
}

export interface IDesignCSSConfig {
	uuid: string;
	variable: string;
	description: string;
	variable_type: string;
	value: string;
}

export interface IDesignCreatePayload {
	name?: string;
	title: string;
	skin?: string;
	logo?: File;
	favicon?: File;
	theme_color?: string;
	watermark?: boolean;
	active?: boolean;
	css_configs?: IDesignCSSConfigPayload[];
	profiles?: string[];
}

export interface IDesignUpdatePayload {
	name?: string;
	title?: string;
	skin?: string;
	logo?: File;
	favicon?: File;
	theme_color?: string;
	watermark?: boolean;
	active?: boolean;
	css_configs?: IDesignCSSConfigPayload[];
	profiles?: string[];
}

export interface IDesignCSSConfigPayload {
	uuid: string;
	value: string;
}

export enum TAB_THEMES {
	LIGHT = 'light',
	DARK = 'dark',
}

export enum DesignStep {
	LIGHT = 'light',
	DARK = 'dark',
}

/** Pestañas de sección del editor de tema (NIF-751). No son campos del contrato API. */
export enum DesignThemeSection {
	GENERAL = 'general',
	TEXT = 'text',
	BUTTONS = 'buttons',
	LINKS = 'links',
	GRAPHICS = 'graphics',
	FEEDBACK = 'feedback',
	FORMS = 'forms',
	BORDERS = 'borders',
	ADVANCED = 'advanced',
}
